import { BaseFieldClass } from './baseField.class'

import { IColorField } from '@/types/serverField.type'

export class ColorFieldClass extends BaseFieldClass {
  declare fieldValue: string
  constructor (field: IColorField) {
    super(field)
    const value = field.Value ?? field.DefaultValue
    this.initialValue = this.prepareValue(value as string | null)
    this.fieldValue = this.prepareValue(value as string | null)
  }

  prepareValue (value: string | null): string {
    return value ?? ''
  }

  getValue () {
    return {
      [this.name]: this.fieldValue
    }
  }

  appendToFormData (formData: FormData): void {
    formData.append(this.name, String(this.fieldValue ?? ''))
  }

  getFilterValue () {
    return this.fieldValue
  }
}
